<template>
  <div class="content">
    <div class="content__row">
      <div class="content__column content__column--wide">
        <h1 class="content__title">Grupos de Galerías</h1>
      </div>
    </div>
    <div class="content__row">
      <group-list :filters="filters"></group-list>
      <group-view :group="group" v-if="groupAction === 'view' && group"></group-view>
      <group-edit @new="newGroup" :group="group" v-if="groupAction === 'edit'" :key="key"></group-edit>
      <div class="content__column content__column--small">
        <h1 class="content__title">Opciones</h1>
        <div class="information">
          <h2 class="content__subtitle">Navegación</h2>
          <router-link class="btn btn__action btn--small" :to="{name: 'galleryView'}">Galerías de imágenes</router-link>
          <h2 class="content__subtitle">Filtro</h2>
          <div class="form__container">
            <label for="search" class="form__label">búsqueda Libre</label>
            <input type="text" name="search" id="search" class="form__input" v-model="search" @keyup="setFilters">
          </div>
        </div>
      </div>
    </div>
    <button @click.prevent="newGroup" class="btn btn__add">Agregar</button>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import groupList from './list'
import groupView from './view'
import groupEdit from './edit'
export default {
  mixins: [
    httpService
  ],
  components: {
    groupList,
    groupView,
    groupEdit
  },
  data: function () {
    return {
      key: 0,
      search: null,
      filters: undefined,
      groupAction: null,
      group: null
    }
  },
  mounted: function () {
    this.$on('view',id => {
      this.getGroup(id, 'view')
    })
    this.$on('edit',id => {
      this.getGroup(id, 'edit')
    })
  },
  methods: {
    setFilters: function () {
      let filter = ''
      if (this.search && this.search.length > 1) {
        filter = 'search=' + this.search
      }
      if (filter.length > 0) {
        this.filters = filter
      } else {
        this.filters = undefined
      }
    },
    getGroup: function (id, action) {
      this.groupAction = action
      let httpRequest = {
        params: '',
        module: 'gallery_groups'
      }
      this.getById(id, httpRequest)
        .then(
          group => {
            this.group = group.data
          }
        )
    },
    newGroup: function () {
      this.group = undefined
      this.key = ++this.key
      this.groupAction = 'edit'
    }
  }
}
</script>

<style lang="sass">
  @import "../../assets/sass/components/_home"
  @import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/gallery_groups/groups.vue